import { memo } from 'react';

import { cn } from '@/lib/utils';

const CancelledIcon = memo(
  ({ width = 20, height = 20, className }: { width?: number; height?: number; className?: string }) => {
    return (
      <div className={cn('text-gray-400', className)}>
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM14.8838 5.11621C14.4261 4.65855 13.7019 4.62979 13.2109 5.03027L13.1162 5.11621L10 8.23242L6.88379 5.11621L6.78906 5.03027C6.29809 4.62979 5.57387 4.65855 5.11621 5.11621C4.65855 5.57387 4.62979 6.29809 5.03027 6.78906L5.11621 6.88379L8.23242 10L5.11621 13.1162C4.62806 13.6044 4.62806 14.3956 5.11621 14.8838C5.60437 15.3719 6.39563 15.3719 6.88379 14.8838L10 11.7676L13.1162 14.8838L13.2109 14.9697C13.7019 15.3702 14.4261 15.3415 14.8838 14.8838C15.3415 14.4261 15.3702 13.7019 14.9697 13.2109L14.8838 13.1162L11.7676 10L14.8838 6.88379L14.9697 6.78906C15.3702 6.29809 15.3415 5.57387 14.8838 5.11621Z"
            fill="currentColor"
          />
        </svg>
      </div>
    );
  }
);

CancelledIcon.displayName = 'CancelledIcon';

export { CancelledIcon };
